import { Contest } from '@/interfaces/contest';
import { ContestResource, contestResource } from '@/resources/contest.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł konkursów
 *
 * @export
 * @class ContestModule
 * @extends {EntityModule<Contest, ContestResource>}
 */
export class ContestModule extends EntityModule<Contest, ContestResource> {
  constructor() {
    super(contestResource);
  }
}

export default new ContestModule();
